import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_aspect_ratio_38a84aed__ from "@radix-ui/react-aspect-ratio";
function AspectRatio({ ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_aspect_ratio_38a84aed__.Root, {
        "data-slot": "aspect-ratio",
        ...props
    });
}
export { AspectRatio };
